/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState,useEffect,useRef  } from "react";
import { useParams } from 'react-router-dom';
import axios from 'axios';
// reactstrap components
import { Container, Row, Col } from "reactstrap";
import { Table } from 'reactstrap';
import { Button } from "reactstrap";
import { connect } from 'react-redux';
import {setProducts,updateCategory,initQuote,uploadProducts} from '../actions/quote'
import Category from "./Category.js"
import { toast } from 'react-toastify';
import { getDateTime } from "../common"


// core components
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import CardsFooter from "components/Footers/CardsFooter.js";
import "react-virtualized/styles.css";
import "assets/vendor/font-awesome/css/font-awesome.min.css";
import Product from "./IndexSections/Product.js";
import OrderHeader from "./IndexSections/OrderHeader.js";



function Index(props) {
  const [openAddProduct, setOpenAddProduct] = useState(false);
  const main = useRef();
  const [role, setRole] = useState();

  const toggleAddProduct = () => {
    console.log("toggle");
    setOpenAddProduct(!openAddProduct);
  } 
  
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const method = queryParams.get('method');
    const userid = queryParams.get('user');
     
    const user = localStorage.getItem('user_bigbrand');
    var role = ""
    if(user && user != undefined){
      var userinfo = JSON.parse(user)
      role = userinfo['role']
    }
    setRole(role);
    if(role=="admin" && !userid){
      toast.error("Invalid userid");
    }
    if(method != "repeat")
      props.initQuote()
    if(method == "repeat"){
    }

    axios.get(`/quotes/add/?userid=${userid}`).then(res => {
      if(res.data.status == "success"){
        if(!props.quote.productUploaded)
          props.uploadProducts();
      }      
      else{        
        // toast.error(res.data);
      }  
    }) 

  },[]);


  const renderCategory=()=>{
    const quote = props.quote;
    const categories = quote.categories;
    var elements = [];
    if(categories[0]){
      const category = categories[0]
      elements.push(
        <Category history={props.history} category={category.category_info} state={category.items} groups={category.groups} updateCategory={props.updateCategory}/>
      )
    }
    else{
      elements.push(
        <Category history={props.history} category={null} state={[]} groups={[]} updateCategory={props.updateCategory}/>
      )
    }

    return elements;
  }


  const submitOrder=async(e, status)=>{
    const {
      selectedContactUser,
      selectedContactAddress,
      selectedContactInfo,
      custom_address,
      logoImage,
      validDate,
      delivery_required,
      pickup_instore,
      collection_id
    } = props.quote;

    const queryParams = new URLSearchParams(window.location.search);
    const userid = queryParams.get('user');

    var quote = props.quote;
    var categories = {...quote.categories};
    for(var key in categories){
      var category = {...categories[key]};
      var items = category['items']
      var groups = [];
      for(var loop = 0; loop < items.length; loop++){
        var groupOptions = items[loop]['group_options'];
        groups.push(groupOptions?groupOptions:{});
      }
      category['groups'] = groups;
      categories[key] = category;
    }
    var bodyFormData = new FormData();
    bodyFormData.append('content', JSON.stringify(categories));
    bodyFormData.append('contact_user',selectedContactUser?selectedContactUser:'')
    bodyFormData.append('contact_address',selectedContactAddress?selectedContactAddress:'')
    bodyFormData.append('contact_info',selectedContactInfo?selectedContactInfo:'')
    bodyFormData.append('custom_address',custom_address?custom_address:'')
    bodyFormData.append('valid_to',validDate?validDate:"")
    bodyFormData.append('delivery_required',delivery_required?"1":"0")
    bodyFormData.append('pickup_instore',pickup_instore?"1":"0")
    bodyFormData.append('collection_id',collection_id?collection_id:'')
    bodyFormData.append('created_at',getDateTime())
    bodyFormData.append('label',quote.quoteLabel?quote.quoteLabel:"")
    bodyFormData.append('price',quote.totalPrice?quote.totalPrice:"")    
    
    if(status)
      bodyFormData.append('status', status);
    if(logoImage)
      bodyFormData.append('logo', logoImage);
    
    if(!delivery_required && !pickup_instore){
      toast.error('You must select a delivery preference. Please try again');
      return;
    }
    if((delivery_required || pickup_instore) && !collection_id){
      toast.error('You must select a collection contact. Please try again');
      return;
    }

    axios.post(`/quotes/add/?userid=${userid}`, bodyFormData).then(res => {
      const result = res.data;
      if(result.status == "success"){        
        toast.success("Your order has been added");
        if(role=="admin")
          props.history.push("/admin/myorders")
        else
          props.history.push("/myorders")
      }
      else{
        toast.error(result.data);
      }
    }).catch(err => {
      toast.error('Something was wrong. Try again');
    })

  }
  return (
    <>
      <DemoNavbar />
      <main ref={main}>
        <Container fluid="lg" className="m-auto">
          <Row>
            <Col  md="12">
              <OrderHeader/>
              {
                renderCategory()
              }
              <div style={{marginTop:'60px'}}>
                <div className="order-nav">
                  <div>
                  </div>
                  <div>
                    <Button
                      onClick={(e)=>submitOrder(e, null)}
                      color="primary" outline
                      className="btn-icon btn-3 rounded-0 border-3" type="button">
                      <span className="btn-inner--text"><b>SAVE DRAFT</b></span>
                    </Button>
                    <Button
                      onClick={(e)=>submitOrder(e,"Requested")}
                      className="btn-icon btn-3 rounded-0 border-3" outline color="primary" type="button">
                      <span className="btn-inner--text"><b>SUBMIT</b></span>
                    </Button>
                  </div>
                </div>   
              </div>
              {openAddProduct &&
              <Product isOpen={openAddProduct} toggle = {toggleAddProduct}
                onAdd={(items, categoryInfo) => {
                  var state=[]
                  var categories = {...props.quote.categories}
                  var category = null
                  for(var catInd in categories){
                    var category = {...categories[catInd]}
                    break;
                  }
                  if(category)
                    state = [...category.items]
                  var newitems = [...items]
                  for(var loop = 0; loop < newitems.length; loop++){
                    var newitem = {...newitems[loop]}
                    newitem['productid'] = newitem['id']
                    var itemCount = 0;
                    for(var loop1 = 0; loop1< state.length; loop1++){
                      itemCount+= state[loop1].length;
                    }
                    newitem['id'] = (loop + itemCount + 1).toString()
                    newitem['type'] = "product";
                    newitems[loop] = newitem
                  }
                  var newstate = [...state, newitems];
                  console.log("newstate", newstate)
                  // setState(newstate);
                  toggleAddProduct();
                  var cat_val={
                    [0]:{
                      category_info: categoryInfo,
                      items: newstate
                    }
                  }
                  props.updateCategory(cat_val)
                }}
              />
              }
            </Col>
          </Row>
        </Container>
      </main>
      <CardsFooter/>
    </>
  );
}


const mapStateToProps = (state) => {
  return {
    quote: state.quote,
  };
};

const mapDispatchProps = (dispatch) => {
  return {    
    setProducts: products=>dispatch(setProducts(products)),
    uploadProducts: ()=>dispatch(uploadProducts()),
    updateCategory: cat=>dispatch(updateCategory(cat)),
    initQuote:()=>dispatch(initQuote()),
  };
};

export default connect(mapStateToProps, mapDispatchProps)(Index);
